import { DatePipe, DecimalPipe } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { TranslateDirective, TranslatePipe } from "@ngx-translate/core";
import { IAtgardskedjaKoppling } from "~app/features/planera/model/IAtgardskedja";
import { IOperation } from "~app/features/planera/model/IOperation";
import { FordelningPipe } from "../../../../common/pipes/fordelning.pipe";
import { PlaneringsstatusIndicatorComponent } from "../../planeringsstatus-indicator/planeringsstatus-indicator.component";
import { PlaneraAtgardBaseComponent } from "../planera-atgard-base.component";

@Component({
    selector: "rask-planera-atgard-grot-popup",
    templateUrl: "./planera-atgard-grot-popup.component.html",
    styleUrls: ["./planera-atgard-grot-popup.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PlaneringsstatusIndicatorComponent,
        TranslateDirective,
        ButtonComponent,
        DecimalPipe,
        DatePipe,
        TranslatePipe,
        FordelningPipe
    ]
})
export class PlaneraAtgardGrotPopupComponent extends PlaneraAtgardBaseComponent {

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("data") set data(value: any) {
        this.arbetsorder = value.arbetsorder;
        this.selectedArbetsorder = value.selectedArbetsorder;
        if (value.atgard.namn === undefined) {
            this.atgardService.getAtgard(value.atgard.guid).subscribe(r => {
                this.atgard = r;
                super.isAtgardAddableCheck();
                this.init();
            });
        } else {
            this.atgard = value.atgard;
            super.isAtgardAddableCheck();
            this.init();
        }
    }

    kopplingar: IAtgardskedjaKoppling[];
    operationer: IOperation[];
    showAndelData = false;

    init() {
        this.kopplingar = this.atgard.atgardskedja?.atgardskedjaKopplingar.filter(k => k.arbetsorderId !== this.atgard.arbetsorderId);
        this.operationer = this.arbetsorder.operationer.filter(o => o.operationstyp === "Skotning");
        this.showAndelData = this.arbetsorderService.hasAtgardAndelData(this.atgard);
    }
}
